module.exports = __webpack_public_path__ + "img/card-tranzactie.dc4ce62b.svg";